module.exports = __webpack_public_path__ + "img/manage-data-4.f9e9d62e.jpg";